export default {
  path: 'winter-service/v2/settings/irregularities',
  name: 'WinterService2SettingsIrregularities',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/IrregularitiesIndex.vue')
}
